import store from '../../config/configureStore';
import { incSubjectVictimRelationshipSchema } from 'simpl-schema-validation/schema';
import { generateHandleEditOffense } from 'simpl-schema-validation/helpers/generateHandleEdit';
import { getCategoryOfCode, getDataOfDictionaryOptions } from 'utils/functions';

export const validateAllIncSubVicRelations = () => {
  const currentState = store.store.getState().incident;
  const dictionary = store.store.getState().dictionary;
  const {
    offenses,
    turnOfValidation,
    incVictims,
    incRelationships,
    incSubjects,
    incRelations,
  } = currentState;
  if (turnOfValidation) return [];

  let validationErrors = [];
  let victimIds = [];
  let subjectIds = [];

  incSubjects.map((s) => {
    if (!subjectIds.includes(s?.incSubjectDetails?.ptsIncPersonId))
      subjectIds.push(s?.incSubjectDetails?.ptsIncPersonId);
  });

  incVictims.map((v) => {
    let vicCategory = getDataOfDictionaryOptions(
      'codeVictimCategory',
      'Code',
      'Category',
      v?.incVictimDetails?.values?.category
    );
    if (
      !victimIds.includes(v?.incVictimDetails?.ptsIncPersonId) &&
      (vicCategory === 'I' || vicCategory === 'L')
    )
      victimIds.push(v?.incVictimDetails?.ptsIncPersonId);
  });

  let victimType = incVictims.find(
    (v) =>
      getDataOfDictionaryOptions(
        'codeVictimCategory',
        'Code',
        'Category',
        v?.incVictimDetails?.values?.category
      ) === 'I'
  );

  offenses.forEach((offense) => {
    if (
      offense.offenseDetails.values.excludeOffense ||
      offense.offenseDetails.values?.statuteDetails?.FBICode === '0'
    )
      return;

    const allRelations = incRelationships
      ? incRelationships.map((relation) => relation.incRelationshipDetails.values.relationship)
      : incRelations
      ? incRelations.map((relation) => relation.Relationship)
      : [];

    const hasVictimWasOffender = allRelations.some(
      (relation) =>
        getCategoryOfCode(dictionary.codeVictimSubjectRelationship, relation?.relationship) === 'vo'
    );
    const objToValidate = {
      allRelations,
      victimIds: victimIds ?? [],
      subjectIds: subjectIds ?? [],
      offensesOffenseForm: offense.offenseDetails,
      victimType,
      hasVictimWasOffender,
      voSubjectIds: hasVictimWasOffender
        ? [
            ...new Set(incSubjects.map((subject) => subject.incSubjectDetails?.ptsIncPersonId)),
          ].filter(Boolean)
        : [],
      voVictimIds: hasVictimWasOffender
        ? [...new Set(incVictims.map((victim) => victim.incVictimDetails?.ptsIncPersonId))].filter(
            Boolean
          )
        : [],
    };

    let allIncSubVicRelationshipsContext = incSubjectVictimRelationshipSchema().newContext();
    let result = allIncSubVicRelationshipsContext.validate(objToValidate, {
      keys: ['allRelations', 'voSubjectIds', 'voVictimIds'],
    });

    if (!result) {
      allIncSubVicRelationshipsContext.validationErrors().forEach((error) => {
        if (offense.offenseDetails.ptsOffenseId) {
          const stepper =
            error.type === 'NIBRS-2019.2-151 Subjects'
              ? 1
              : error.type === 'NIBRS-2019.2-151 Victims'
              ? 2
              : 3;
          validationErrors.push({
            id: offense.offenseDetails.ptsOffenseId,
            idType: 'ptsOffenseId',
            ptsOffenseId: offense.offenseDetails.ptsOffenseId,
            ptsIncidentId: currentState.ptsIncidentId,
            errType: error.type,
            field: error.name,
            stepper,
            screen: stepper === 1 || stepper === 2 ? 'Offense' : 'Offense Relationship',
            name:
              offense.offenseDetails.values.statuteDetails?.Description +
              ' | ' +
              offense.offenseDetails.values.statuteDetails?.Code,
            message: allIncSubVicRelationshipsContext.keyErrorMessage(error.name),
            identifier: `${currentState.ptsIncidentId}-${error.type.split('-').pop()}-${
              error.name
            }-OffenseRelationship-${offense.offenseDetails.ptsOffenseId}`,
            handleEdit: generateHandleEditOffense(
              currentState.ptsIncidentId,
              offense.offenseDetails.ptsOffenseId,
              stepper
            ),
          });
        }
      });
    }
  });

  return validationErrors;
};
